
import angular from "angular";
import ValueTokenFactory from "./ValueTokenFactory";
import ScopeTokenFactory from "./ScopeTokenFactory";
import OpTokenFactory from "./OpTokenFactory";

export default angular
    .module("trackerbase-app.models.factories.token-factories",[])
    .service("ValueTokenFactory", ValueTokenFactory) // injector params in $inject
    .service("ScopeTokenFactory", ScopeTokenFactory) // injector params in $inject
    .service("OpTokenFactory", OpTokenFactory) // injector params in $inject
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/token-factories/index.js
// module id = mb8i
// module chunks = 1